import React, { useEffect, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import DashboardSkeleton from "../../common/DashboardSkeleton";
import { Search } from "lucide-react";
import InfoTooltip from "../../common/InfoTooltip";

const Citywisetable = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [cityData, setCityData] = useState([]);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  function formatDateForApi(date, type) {
    if (!date) return "";
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    let hours = type === "start" ? "00" : "23";
    let minutes = type === "start" ? "00" : "59";
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  useEffect(() => {
    getCityWiseData();
  }, []);

  const getCityWiseData = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    const formattedStartDate = formatDateForApi(
      selectionRange?.startDate,
      "start",
    );
    const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/booking-dashboard-city-kpi?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setCityData(data?.dataValues);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };

  const result =
    cityData?.cityWiseReport &&
    Object.entries(cityData?.cityWiseReport).map(([cityId, data]) => ({
      cityId,
      cityName: cities[cityId] || "Unknown City",
      ...data,
    }));

  return (
    <>
      {loading ? (
        <DashboardSkeleton />
      ) : (
        <>
          <div className="w-full my-2 bg-white border-b border-[#E5E7EB] shadow-sm px-8 py-5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 my-6 rounded-lg">
            <div className="flex items-center gap-3">
              <h1 className="text-gray-900 text-2xl font-bold tracking-tight">
                City Data
              </h1>
              <InfoTooltip
                position="right"
                content={
                  <div className="space-y-1 text-xs">
                    {/* <p>
                      <strong>City Total Bookings:</strong> Count(Bookings in
                      City)
                    </p>
                    <p>
                      <strong>City Total Revenue:</strong> Σ (Booking Revenue in
                      City)
                    </p>
                    <p>
                      <strong>City Total Days Run:</strong> Σ (Trip Duration in
                      City)
                    </p> */}
                    <p>
                      <strong>City Utilization Rate:</strong> (City Total Days
                      Run ÷ (Fleet Size × Target Days)) × 100
                    </p>
                    <p>
                      <strong>City Average Revenue Per Booking:</strong> City
                      Total Revenue ÷ City Total Bookings
                    </p>
                    <p>
                      <strong>City Average Trip Duration:</strong> City Total
                      Days Run ÷ City Total Bookings
                    </p>
                  </div>
                }
              />
            </div>

            <div className="flex gap-4 justify-end">
              <DaterangePicker
                selectionRange={selectionRange}
                setSelectionRange={setSelectionRange}
                style={-10}
              />

              <button
                onClick={() => {
                  getCityWiseData();
                }}
                className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg"
              >
                <Search size={18} />
                Search
              </button>
            </div>
          </div>
          <div>
            <div className="w-full p-8 bg-white rounded-2xl shadow-[0px_10px_28px_-10px_rgba(0,0,0,0.05)] outline outline-1 outline-gray-200 inline-flex flex-col justify-start items-start">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch h-16 px-6 py-4 bg-indigo-50 rounded-2xl border-b border-slate-300 inline-flex justify-start items-center gap-12">
                  <div className="w-48 justify-start text-gray-900 text-lg font-semibold font-['Outfit'] leading-6">
                    City
                  </div>
                  <div className="w-28 justify-start text-gray-900 text-lg font-semibold font-['Outfit'] leading-6">
                    Bookings
                  </div>
                  <div className="w-36 justify-start text-gray-900 text-lg font-semibold font-['Outfit'] leading-6">
                    Car Days
                  </div>
                  <div className="w-40 justify-start text-gray-900 text-lg font-semibold font-['Outfit'] leading-6">
                    Avg Util(Days)
                  </div>
                  <div className="w-36 justify-start text-gray-900 text-lg font-semibold font-['Outfit'] leading-6">
                    Avg Trip Duration
                  </div>
                  <div className="w-36 justify-start text-gray-900 text-lg font-semibold font-['Outfit'] leading-6">
                    Avg Revenue
                  </div>
                  <div className="flex-1 justify-start text-gray-900 text-lg font-semibold font-['Outfit'] leading-6">
                    Total Revenue
                  </div>
                </div>
                {result ? (
                  result.map((data, index) => (
                    <div className="self-stretch h-20 px-6 py-5 bg-white border-b border-gray-200 inline-flex justify-start items-center gap-12">
                      <div className="w-48 flex justify-start items-center gap-2">
                        <div className="flex-1 justify-start text-gray-900 text-xl font-bold font-['Outfit'] leading-7">
                          {data?.cityName || "-"}
                        </div>
                      </div>
                      <div className="w-36 justify-start text-gray-700 text-xl font-semibold font-['Outfit'] leading-7">
                        {data?.totalBookings || "-"}
                      </div>
                      <div className="w-32 justify-start text-gray-700 text-xl font-semibold font-['Outfit'] leading-7">
                        {data?.totalDaysRun || "-"}
                      </div>
                      <div className="w-40 justify-start text-gray-700 text-xl font-semibold font-['Outfit'] leading-7">
                        {data?.cityUtilizationRate || "-" + " days"}
                      </div>
                      <div className="w-36 justify-start text-gray-700 text-xl font-semibold font-['Outfit'] leading-7">
                        {data?.averageTripDuration || "-" + " days"}
                      </div>
                      <div className="w-36 justify-start text-gray-700 text-xl font-semibold font-['Outfit'] leading-7">
                        {"₹ " + data?.averageRevenuePerBooking || "-"}
                      </div>
                      <div className="flex-1 justify-start text-gray-700 text-xl font-semibold font-['Outfit'] leading-7">
                        {"₹ " + data?.totalRevenue || "-"}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center font-semibold p-4">
                    No Data Found
                  </div>
                )}

                <div className="w-full bg-blue-50 border border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-md transition-all duration-300">
                  <div className="flex items-center justify-between">
                    <div className="text-right">
                      <p className="text-xs text-gray-400 uppercase tracking-wide">
                        For all cities
                      </p>
                      <div className="mt-2 inline-flex items-center gap-1 bg-orange-50 text-orange-600 px-3 py-1 rounded-full text-sm font-semibold">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5 10a1 1 0 011.707-.707L9 11.586l4.293-4.293A1 1 0 0114.707 8.707l-5 5a1 1 0 01-1.414 0l-3-3A1 1 0 015 10z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Across all cities
                      </div>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 font-semibold">
                        Total Revenue
                      </p>

                      <h2 className="text-3xl font-bold text-green-400 mt-1">
                        ₹
                        {result
                          ?.reduce(
                            (sum, item) => sum + Number(item.totalRevenue || 0),
                            0,
                          )
                          ?.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Citywisetable;
